<div class="main overflow-x px-2">
        <div class="iransans my-4 text-center row">
            <div class="col-9 m-auto">
                <input type="text" class="form-control font-14" placeholder="جستجو کنید">
            </div>
            <div class="col-3">
                <button mat-button (click)="onClose()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div class="row my-2">
            <div class="iransans-bold text-center">
                مقاله را بر اساس حرف اول پیدا کنید
            </div>
        </div>
       <div class="row m-0">
        <div class="col-3" *ngFor="let item of alphabetList">
            <button mat-button class="alphabet-button">
                {{item}}
            </button>
        </div>
       </div>
</div>